// @ts-nocheck
/* eslint-disable */ /* GENERATED USING build-GemIcons.ts - DO NOT MODIFY */ import { ReactComponent as LogoBigquery } from '../../../assets/images/Logos/logo-bigquery.svg?react';
import { withLogoClass } from '../../withLogoClass';
export const LogoBigqueryIcon = /* @__PURE__ */ withLogoClass(LogoBigquery);
